import { Box, styled } from "@mui/material";

type StyledProjectProps = {
  status: string;
};

export const StyledProject = styled(Box)<StyledProjectProps>(
  ({ theme, status }) => ({
    width: "100%",
    paddingInline: ".5rem",
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gridTemplateRows: "repeat(13, 1fr)",
    maxHeight: "100vh",
    gap: ".5rem",
    paddingBottom: "1rem",
    boxSizing: "border-box",
    position: "relative",
    ".header": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gridArea: "1 / 1 / 2 / 4",
      h1: {
        color: theme.color.dark,
        borderBottom: `5px solid ${
          status === "Finished"
            ? theme.palette.success.main
            : status === "InProgress"
              ? theme.palette.warning.main
              : status === "Rejected"
                ? theme.palette.error.main
                : status === "QuoteSent"
                  ? theme.color.main
                  : theme.contrast.lighter
        }`,
      },
      ".backbtn": {
        position: "absolute",
        left: "0rem",
        display: "flex",
        gap: "1rem",
      },
    },
    [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
      ".header": {
        h1: {
          fontSize: "3rem",
        },
      },
    },
  }),
);
